export default "__VITE_ASSET__140875a9__"